module.exports = __webpack_public_path__ + "static/media/just-eat.5d6053a5.png";